import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { useToast } from "@/hooks/use-toast";

export default function PromoCodesTab() {
  const [codes, setCodes] = useState<any[]>([]);
  const [code, setCode] = useState("");
  const [discount, setDiscount] = useState("10");
  const [maxUses, setMaxUses] = useState("");
  const { toast } = useToast();

  const load = async () => {
    const { data } = await supabase.from("promo_codes").select("*").order("created_at", { ascending: false });
    setCodes(data ?? []);
  };
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!code) return;
    const { error } = await supabase.from("promo_codes").insert({
      code: code.toUpperCase(),
      discount_percent: Number(discount),
      max_uses: maxUses ? Number(maxUses) : null,
    });
    if (error) toast({ title: "Error", description: error.message, variant: "destructive" });
    else { toast({ title: "Created" }); setCode(""); load(); }
  };

  const toggle = async (id: string, active: boolean) => {
    await supabase.from("promo_codes").update({ is_active: !active }).eq("id", id);
    load();
  };

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader><CardTitle>Create Promo Code</CardTitle></CardHeader>
        <CardContent className="grid grid-cols-1 md:grid-cols-4 gap-2">
          <Input placeholder="CODE" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} />
          <Input type="number" placeholder="% off" value={discount} onChange={(e) => setDiscount(e.target.value)} />
          <Input type="number" placeholder="Max uses (optional)" value={maxUses} onChange={(e) => setMaxUses(e.target.value)} />
          <Button onClick={create}>Create</Button>
        </CardContent>
      </Card>
      <Card>
        <CardHeader><CardTitle>All Codes ({codes.length})</CardTitle></CardHeader>
        <CardContent className="space-y-2">
          {codes.map(c => (
            <div key={c.id} className="flex justify-between items-center p-3 border rounded">
              <div>
                <div className="font-mono font-bold">{c.code}</div>
                <div className="text-xs text-muted-foreground">{c.discount_percent}% off · {c.used_count}/{c.max_uses ?? "∞"} used</div>
              </div>
              <div className="flex gap-2 items-center">
                <Badge variant={c.is_active ? "default" : "secondary"}>{c.is_active ? "Active" : "Inactive"}</Badge>
                <Button size="sm" variant="outline" onClick={() => toggle(c.id, c.is_active)}>Toggle</Button>
              </div>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
